import React, {useCallback, useState} from 'react';
import styles from './styles';
import Tabs from './Tabs';
import trialSettings from '../TrialUI/trialSettings';
import {InstanceContext} from '../../InstanceContext';
import {UserContext} from '../../Context/UserContext';
import {Route} from 'react-router-dom';
import {styleHandler} from '@xpertdox_js/xdcomponents';
import { trackActivity } from '../../utils/activityTracker'

const Navbar = props => {
  const {contextInstance, updateContextInstance} = React.useContext(InstanceContext);
  const {user, userAction} = React.useContext(UserContext);
  const deducedInstance = user.accountType === 'PI' ? 'PI' : contextInstance || user.instance;

  // track sub menu content
  const [subMenuContent, setSubMenuContent] = useState(null);
  const [subMenuExpand, setSubMenuExpand] = useState(true);
  const [subMenuBtn, setSubMenuBtn] = useState(false);

  // activity log
  const handleActivityLogUpdate = (_id) => trackActivity({body: {
    _id,
    instance: contextInstance || user.instance,
    user: user.id
  }})

  // change instance
  const handleInstanceSelect = (val) => {
    handleActivityLogUpdate(`Navbar.handleInstanceSelect.(${val})`)
    updateContextInstance({type: 'updateInstance', instance: val});
    userAction({ type: 'updateUser', property: 'instance', value: val})
    // this push call has been added here because the api call is happening for only root location
    // this is a temp fix
    props.history.push('/')
    setTimeout(() => props.history.push(`/${val}/`, {title: 'XpertConsole'}))
  }

  // get nav items using instance
  const navItems = (trialSettings.instances[deducedInstance] || trialSettings.instances.default).tabs
  .map(menuItemID => {return({...trialSettings.tabs[menuItemID], trialTabID: menuItemID})})

  // set nav spacing when needed
  const setNavSpacing = useCallback(node => node ? props.setNavSpacing(node.clientWidth) : null)

  const setToggleState = () => {
    setSubMenuExpand(!subMenuExpand)
    if (!subMenuExpand) setSubMenuBtn(true);
    handleActivityLogUpdate(`Navbar.setToggleState`)
  }

  // ----- routes for sub menu
  // all trial related routes
  const trialRoutes = [
    '/:instance/trials_home/',
    '/trial_list/:instance/allTrials',
    '/trial_list/:instance/customDescription',
    '/trial_list/:instance/studyContacts',
    '/trial_list/:instance/specialtyContacts',
    '/trial_list/:instance/addTrials',
    '/trial_list/:instance/studyLocation',
    '/trial_list/:instance/bulkUploads',
    '/:instance/trials/overview/:id',
  ];
  // all patient related routes
  const patientRoutes = [
    '/trial_list/:instance/searchPatients',
    '/trial_list/:instance/emailRecords',
    '/trial_list/:instance/xpertTriage',
    '/trial_list/:instance/triageStudies',
    '/trial_list/:instance/triagePatients',
    '/trial_list/:instance/triageSource',
    '/:instance/user/overview/:id',
    '/:instance/patients/'
  ]

  const userRoutes = [
    '/trial_list/:instance/userManagement',
    '/trial_list/:instance/userActivity'
  ]

  // concat all routes into one list
  const navRoutes = trialRoutes.slice().concat(patientRoutes).concat(userRoutes);


  return(
    <div
      style={styles.dashSidebar}
      id='application_navigation_bar'
      ref={setNavSpacing}
    >
      <nav
        style={{...styles.container, borderRight: !subMenuExpand && '1px solid rgba(0, 0, 0, 0.12)'}}
      >
        <div style={styles.navContentWrap}>
            <Tabs
              navItems={navItems}
              auth={props.auth}
              setInstance={handleInstanceSelect}
              instance={(contextInstance || user.instance)}
              setSubMenuContent={setSubMenuContent}
              subMenuContent={subMenuContent}
            />
        </div>
        {deducedInstance !== 'PI' &&
          <Route
            path={navRoutes}
            component={props =>
              <div
                onMouseEnter={() => subMenuExpand && setSubMenuBtn(true)}
                onMouseLeave={() => subMenuExpand && setSubMenuBtn(false)}
                style={styleHandler([styles.navSubContentWrap, !subMenuExpand && styles.navSubContentWrapCollapsed])}
              >
                {
                  // subMenuBtn &&
                  // <IconButton
                  //   styles={styles.expandBtn}
                  //   onClick={() => setToggleState()}
                  //   preBuiltStyles={btn_c_xdDarkToHighlight}
                  //   icon={subMenuExpand ? 'x' : 'menu'}
                  //   size='sm'
                  // />
                }
                {subMenuContent && subMenuExpand &&
                  <React.Fragment>
                    <Route
                      path={trialRoutes}
                      component={props =>
                        <React.Fragment>
                          {subMenuContent.trials.map(elem => {
                            return React.cloneElement(elem, {
                                ...elem.props,
                                styles: styles.subMenuItem,
                                hoverStyles: styles.subMenuItemHov,
                                activeStyles: styles.subMenuItemActive
                              },
                              elem.children
                            );
                          })}
                        </React.Fragment>
                      }
                    />
                    {/* user hover menu set by tab item */}
                    <Route
                      path={patientRoutes}
                      component={props =>
                        <React.Fragment>
                          {subMenuContent.patients}
                        </React.Fragment>
                      }
                    />
                    <Route
                      path={userRoutes}
                      component={props =>
                        <React.Fragment>
                          {subMenuContent.users}
                        </React.Fragment>
                      }
                    />
                  </React.Fragment>}
              </div>
            }
          />
        }
      </nav>
    </div>
  )
}


// Navbar.propTypes = {
//     setInstance: PropTypes.func.isRequired,
// }


export default Navbar;
